module.exports = __webpack_public_path__ + "assets/img/sbg.39f61653.png";